<template>
  <div class="ma-4">
      <v-snackbar
          v-model="msg"
          top
          :color="snackbarColor"
          :timeout="3000"
          elevation="4"
          class="rounded-lg"
      >
          <div class="d-flex align-center">
              <v-icon class="mr-2">{{
                  snackbarColor === "success" ? "mdi-check-circle" : "mdi-alert"
              }}</v-icon>
              {{ text }}
          </div>
          <template v-slot:action="{ attrs }">
              <v-btn icon small v-bind="attrs" @click="msg = false">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
          </template>
      </v-snackbar>

      <v-card class="rounded-lg" min-height="800">
          <v-app-bar flat dense color="grey lighten-4" class="rounded-t-lg px-3">
              <v-btn icon small class="mr-2 grey lighten-3" @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
              </v-btn>

              <span class="text-h6 font-weight-medium grey--text text--darken-3">
                  Performance Report
              </span>

              <v-spacer></v-spacer>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text class="pa-6 grey lighten-5">
              <v-row dense>
                  <v-col cols="12" sm="4">
                      <v-select
                          label="Select Report Type"
                          v-model="reportFilters.newReport"
                          :items="reports"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                          @change="updateTimeIncrements()"
                      ></v-select>
                  </v-col>

                  <v-col cols="12" sm="4">
                      <v-select
                          label="Filter By"
                          v-model="reportFilters.newFilter"
                          :items="filters"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-select>
                  </v-col>

                  <v-col cols="12" sm="4">
                      <v-select
                          label="Times Later Than:"
                          :items="availableTimeIncrements"
                          v-model="reportFilters.newTime"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-select>
                  </v-col>

                  <v-col cols="12" md="2">
                      <v-menu
                          ref="calendarMenu"
                          v-model="calendarMenu"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                          <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="reportFilters.startDate"
                                  label="Start Date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  outlined
                                  dense
                                  hide-details
                                  class="rounded-lg"
                                  background-color="white"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules='requiredField'
                                  clearable
                              ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="reportFilters.startDate"
                              no-title
                              scrollable
                              :rules='requiredField'
                              color="primary"
                              class="rounded-lg"
                          >
                          </v-date-picker>
                      </v-menu>
                  </v-col>

                  <v-col cols="12" md="2">
                      <v-menu
                          ref="calendar2Menu"
                          v-model="calendar2Menu"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                          <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="reportFilters.endDate"
                                  label="End Date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  outlined
                                  dense
                                  hide-details
                                  class="rounded-lg"
                                  background-color="white"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules='requiredField'
                                  clearable
                              ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="reportFilters.endDate"
                              no-title
                              scrollable
                              :rules='requiredField'
                              color="primary"
                              class="rounded-lg"
                          >
                          </v-date-picker>
                      </v-menu>
                  </v-col>

                  <v-col cols="12" md="3" v-if="reportFilters.newFilter == 'Staff'">
                      <v-select
                          label="Staff Status"
                          :items="staffStatuses"
                          v-model="reportFilters.staffStatus"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-select>
                  </v-col>

                  <v-col cols="12" md="3" v-if="reportFilters.newFilter == 'Staff' && reportFilters.newReport != 'Late ADL\'s'">
                      <v-autocomplete 
                          label="Select Staff"
                          :items="filteredStaff"
                          item-text="Name"
                          item-value="_id"
                          v-model="reportFilters.StaffID"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="3" v-if="reportFilters.newFilter == 'Staff' && reportFilters.newReport == 'Late ADL\'s'">
                      <v-autocomplete 
                          label="Select Staff"
                          :items="filteredStaff"
                          item-text="Name"
                          item-value="Name"
                          v-model="reportFilters.StaffID"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="3" v-if="reportFilters.newFilter == 'Program'">
                      <v-autocomplete 
                          label="Select Program"
                          :items="programs"
                          item-text="Name"
                          item-value="_id"
                          v-model="reportFilters.newProgram"
                          outlined
                          dense
                          hide-details
                          class="rounded-lg"
                          background-color="white"
                          clearable
                      ></v-autocomplete>
                  </v-col>

                  <v-col cols="3" class="d-flex justify-center">
                      <v-btn 
                          color="primary"
                          block
                          height="40"
                          class="rounded-lg"
                          :loading="isLoading"
                          elevation="1"
                          @click="generateReport()"
                      >
                          <v-icon left>mdi-magnify</v-icon>
                          Generate Report
                      </v-btn>
                  </v-col>
              </v-row>

              <v-row v-if="showResults" class="mt-4">
                  <v-col cols="12">
                      <v-card class="pa-4 blue-grey lighten-5 rounded-lg">
                          <v-row>
                              <v-col cols="12" md="4" class="text-center">
                                  <h3 class="text-h6 grey--text text--darken-2">Total Entries</h3>
                                  <h2 class="text-h4 primary--text font-weight-bold">{{ totalTimesheets }}</h2>
                              </v-col>
                              <v-col cols="12" md="4" class="text-center">
                                  <h3 class="text-h6 grey--text text--darken-2">Late Entries</h3>
                                  <h2 class="text-h4 warning--text font-weight-bold">{{ lateEntries }}</h2>
                              </v-col>
                              <v-col cols="12" md="4" class="text-center">
                                  <h3 class="text-h6 grey--text text--darken-2">Late Percentage</h3>
                                  <h2 class="text-h4 error--text font-weight-bold">{{ latePercentage }}%</h2>
                              </v-col>
                          </v-row>
                      </v-card>
                  </v-col>
              </v-row>
          </v-card-text>

          <!-- Data Tables -->
          <v-card-text class="pa-6" v-if="showClockIn">
              <v-data-table
                  :headers="currentHeaders"
                  :items="timesheets"
                  sort-by="ClockIn"
                  sort-asc
                  class="elevation-1 rounded-lg"
                  :loading="isLoading"
                  loading-text="Loading Clock In Data"
                  :items-per-page="100"
                  :footer-props="{
                      'items-per-page-options': [25, 50, 100, 200],
                      showFirstLastPage: true,
                      'items-per-page-text': 'Rows per page:',
                      class: 'rounded-lg',
                  }"
              >
              </v-data-table>
          </v-card-text>

          <v-card-text class="pa-6" v-if="showADL">
              <v-data-table
                  :headers="adlHeaders"
                  :items="adlData"
                  sort-by="ClockIn"
                  sort-asc
                  class="elevation-1 rounded-lg"
                  :loading="isLoading"
                  loading-text="Loading ADL Data"
                  :items-per-page="100"
                  :footer-props="{
                      'items-per-page-options': [25, 50, 100, 200],
                      showFirstLastPage: true,
                      'items-per-page-text': 'Rows per page:',
                      class: 'rounded-lg',
                  }"
              >
              </v-data-table>
              
              <!-- Load More Button for ADL Data -->
              <v-row v-if="adlPagination && adlPagination.hasMore" class="mt-4">
                  <v-col cols="12" class="text-center">
                      <v-btn
                          color="primary"
                          outlined
                          :loading="isLoading"
                          @click="loadMoreADLData"
                      >
                          <v-icon left>mdi-download</v-icon>
                          Load More ADL Data ({{ adlData.length }} of {{ totalTimesheets }} loaded)
                      </v-btn>
                  </v-col>
              </v-row>
          </v-card-text>

          <v-card-text class="pa-6" v-if="showMAR">
              <v-data-table
                  :headers="marHeaders"
                  :items="marData"
                  sort-by="Date"
                  sort-asc
                  class="elevation-1 rounded-lg"
                  :loading="isLoading"
                  loading-text="Loading MAR Data"
                  :items-per-page="100"
                  :footer-props="{
                      'items-per-page-options': [25, 50, 100, 200],
                      showFirstLastPage: true,
                      'items-per-page-text': 'Rows per page:',
                      class: 'rounded-lg',
                  }"
              >
              </v-data-table>

              <!-- Load More Button for MAR Data -->
              <v-row v-if="marPagination && marPagination.hasMore" class="mt-4">
                  <v-col cols="12" class="text-center">
                      <v-btn
                          color="primary"
                          outlined
                          :loading="isLoading"
                          @click="loadMoreMARData"
                      >
                          <v-icon left>mdi-download</v-icon>
                          Load More MAR Data ({{ marData.length }} of {{ totalTimesheets }} loaded)
                      </v-btn>
                  </v-col>
              </v-row>
          </v-card-text>
      </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { setUserTz, tz } from "../../../utils/timezone";
// import ReportHeader from '@/components/Report/ReportHeader.vue';
import {
STATUS_ARRAY,
STATUSES as UserStatus
} from "../../enums/UserStatusEnum";
import { STATUSES as StaffStatus } from "../../enums/StaffStatusEnum";
import { mapGetters } from "vuex";

// import { PDFDocument } from "pdf-lib";
// import moment from 'moment'
// import Foot from '../components/Footer'

import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../../client_config/config").url;

export default {
  mixins: [
    ReportFilters,
  ],
  components: {
      // ReportHeader
  },
  data: () => ({
  clockInHeaders: [
    {
      text: 'Staff',
      align: 'start',
      sortable: true,
      value: 'Employee.Name',
    },
    { text: "Actual Clock In", value: "ClockIn" },
    { text: "Scheduled Start Time", value: "ClockInSchedule" },
    { text: "Time Difference", value: "timeDifference" },
    
    { text: "", value: "select" },

  ],
  clockOutHeaders: [
    {
      text: 'Staff',
      align: 'start',
      sortable: true,
      value: 'Employee.Name',
    },
    { text: "Actual Clock Out", value: "ClockOut" },
    { text: "Scheduled End Time", value: "ClockOutSchedule" },
    { text: "Time Difference", value: "timeDifference" },
    
    { text: "", value: "select" },

  ],
  adlHeaders: [
    {
      text: 'Date',
      align: 'start',
      sortable: true,
      value: 'Date',
    },
    { text: "ADL", value: "ServiceItem" },
    { text: "Staff", value: "Employee" },
    { text: "Client", value: "ClientName" },      
    { text: "Time", value: "Time" },      
    { text: "Signature", value: "Signature" },      
    { text: "Time Difference", value: "timeDifference" },      
    { text: "", value: "select" },

  ],
  marHeaders: [
    {
      text: 'Date',
      align: 'start',
      sortable: true,
      value: 'Date',
    },
    { text: "Admin Time", value: "AdminTime" },     
    { text: "Medication", value: "Medication" },
    { text: "Staff", value: "Employee" },
    { text: "Client", value: "ClientName" },      
    // { text: "Actual Admin Time", value: "ActualAdminTime" },      
    { text: "Signature", value: "Signature" },      
    { text: "Time Difference", value: "timeDifference" },      
    { text: "", value: "select" },

  ],
  date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
  employees: [],
  programs: [],
  reports: [
      "Late Clock In",
      "Late Clock Out",
      "Late ADL's",
      "Late Meds",
      // "Inservice Training"
  ],
  filters: [
      "Staff",
      "Program",
  ],
  dialog: false,
  calendarMenu: false,
  calendar2Menu: false,
  isLoading: false,
  role: localStorage.getItem('userRole'),
  state: localStorage.getItem('userState'),
  requiredField: [
      v => !!v || 'This is required',
  ],
  msg: false,
  search: "",
  text: "",
  tempData: [],
  users: [],
  timesheets: [],
  adlData: [],
  marData: [],
  userID: localStorage.getItem("userID"),
  // Pagination properties for ADL data
  adlCurrentPage: 1,
  adlPagination: null,
  // Pagination properties for MAR data
  marCurrentPage: 1,
  marPagination: null,
  latePercentage: "",
  totalTimesheets: "",
  lateEntries: "",
  staffStatuses: STATUS_ARRAY,
  timeIncrements: [
      "15 Minutes",
      "30 Minutes",
      "45 Minutes",
      "1 Hour",
      "8 Hours"
  ],
  lateMedsTimeIncrements: [
      '15 minutes', 
      '30 minutes', 
      '45 minutes', 
      '1 hour', 
      '1 hour 15 minutes', 
      '1 hour 30 minutes', 
      '1 hour 45 minutes', 
      '2 hours', 
      '3 hours', 
      '4 hours',
      '8 hours',
  ], 
  availableTimeIncrements: [],
  showClockIn: false,
  showADL: false,
  showMAR: false,
  showTraining: false,
  showResults: false,
  useFirstHeader: true,
  reportFilters:  {
    newReport: '',
    newFilter: '',
    newTime: '',
    startDate: '',
    endDate: '',
    staffStatus: '',
    StaffID: '',
    newProgram: '',
  },
  reportFilterName: 'ReportFilters_PerformanceReport',
  snackbarColor: "success",

  }),

  computed: {
    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
    }),
    currentHeaders() {
      return this.reportFilters.newReport === 'Late Clock In' ? this.clockInHeaders : this.clockOutHeaders;
    },
    filteredStaff() {
      const staffs = this.users;

      if (this.reportFilters.staffStatus === UserStatus.INACTIVE) {
        return staffs.filter(
          (staff) => staff.Status == StaffStatus.TERMINATED
        );
      }

      if (this.reportFilters.staffStatus === UserStatus.ACTIVE) {
        return staffs.filter(
          (staff) =>
            staff.Status == StaffStatus.FULL_TIME ||
            staff.Status == StaffStatus.PART_TIME
        );
      }

      return staffs;
    },
    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },
    queryParameters() {
      return {
          programId: this.reportFilters.newProgram,
          staffId: this.reportFilters.StaffID,
          report: this.reportFilters.newReport,
          startDate: this.reportFilters.startDate,
          endDate: this.reportFilters.endDate,
          time: this.reportFilters.newTime,
          tz: this.userTimezone, 
      }
    }
    
  },

  created() {
    this.getEmployees();
    this.getPrograms();

    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;

    if (this.reportFilters.newReport) {
      this.updateTimeIncrements();
    }
  },
  

  watch: {
    reportFilters: {
        handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
    }
  },

  methods: {
    initialize() {
      this.inventories = [];
    },

    updateTimeIncrements() {
      this.clearFilters();
      this.availableTimeIncrements = this.timeIncrements;
      // Update the available time increments based on selected report type
      if (this.reportFilters.newReport === 'Late Meds') {
        this.availableTimeIncrements = this.lateMedsTimeIncrements;
      }
      
      // Clear StaffID when switching between report types to prevent ObjectID conversion errors
      // Late ADL's uses staff names, other reports use ObjectIDs
      this.reportFilters.StaffID = '';
    },

    async getEmployees () {
      let endpoint = '';
      const companyIds = localStorage.getItem('userCompanies');

      endpoint = `${url}/users/state/${this.state}`;

      await axios.get(endpoint, {
        params: {
          Company: JSON.parse(companyIds)
        }
      }).then(res => {
        this.users = res.data.users;
        
      });       
    },

    async getPrograms () {
      let endpoint = '';
      const companyIds = localStorage.getItem('userCompanies');

      endpoint = `${url}/units/status/company`;

      await axios.get(endpoint, {
        params: {
          Company: JSON.parse(companyIds)
        }
      }).then(res => {
        this.programs = res.data.units;
        
      });       
    },

    close() {
      this.dialog = false;

    },
    
    async generateClockInQuery() {
  try {
      this.isLoading = true;
      
      if (!this.reportFilters.newFilter || !this.reportFilters.newReport || !this.reportFilters.startDate || !this.reportFilters.endDate || !this.reportFilters.newTime) {
          this.msg = true;
          this.text = "Please select all required fields including the time threshold!";
          return;
      }

      // Debug logging
      console.log('Frontend query parameters:', this.queryParameters);
      console.log('Time threshold selected:', this.reportFilters.newTime);
      
      // Example of calling the API endpoint
      const response = await axios.get(`${url}/timesheets/reports/late/clockin/late-clock-in-percentage`, {
          params: this.queryParameters
      });

      console.log('Server response:', response.data); // Log the entire response for debugging

      const latePercentage = parseFloat(response.data.percentage); // Convert to a number
      const totalTimesheets = response.data.totalTimesheets;
      const lateEntries = response.data.lateEntries;
      
      // Update the state with the received data
      this.latePercentage = latePercentage;
      this.totalTimesheets = totalTimesheets;
      this.lateEntries = lateEntries;
      this.timesheets = response.data.data;

      // Show the results
      // this.msg = true;
      // this.text = `Late Clock-In Percentage: ${latePercentage.toFixed(2)}%`; 
      this.showClockIn = true;
      this.showResults = true;

  } catch (error) {
      console.error('Error generating query:', error.response ? error.response.data : error); // Log the error response
      this.msg = true;
      this.text = "Failed to generate report. Please try again.";
  } finally {
      this.isLoading = false;
  }
},

async generateADLQuery() {
  try {
      this.isLoading = true;
      
      // Check if required fields are selected
      if (!this.reportFilters.startDate || !this.reportFilters.endDate) {
          this.msg = true;
          this.text = "Please select all required fields!";
          return;
      }

      console.log(this.queryParameters, this.userTimezone);

      // Reset pagination for new query
      this.adlCurrentPage = 1;
      this.adlData = [];

      // Example of calling the ADL API endpoint with timezone
      const response = await axios.get(`${url}/adl/report/performance/late/adl/test`, {
          params: {
              ...this.queryParameters,
              page: this.adlCurrentPage,
              limit: 1000 // Load 1000 records per page
          }
      });

      // Example response data handling
      const adlData = response.data.result;

      // Process and format the data - use DateTZ if available, otherwise format the Date
      this.adlData = adlData.map((item) => ({
          ...item,
          Date: item.DateTZ || tz(item.Date, this.userTimezone).format("YYYY-MM-DD"), // Use DateTZ if available
      }));

      // Update additional data based on the response
      const latePercentage = response.data.latePercentage;
      const totalTimesheets = response.data.totalEntries;
      const lateEntries = response.data.lateEntries;

      this.latePercentage = latePercentage;
      this.totalTimesheets = totalTimesheets;
      this.lateEntries = lateEntries;

      // Store pagination info
      this.adlPagination = response.data.pagination;

      // Display ADL data
      this.showADL = true;
      this.showResults = true;

  } catch (error) {
      console.error('Error fetching ADL data:', error);
      this.msg = true;
      this.text = "Failed to fetch ADL data. Please try again.";
  } finally {
      this.isLoading = false;
  }
},

async loadMoreADLData() {
  try {
      if (!this.adlPagination || !this.adlPagination.hasMore) {
          return;
      }

      this.adlCurrentPage++;
      
      const response = await axios.get(`${url}/adl/report/performance/late/adl/test`, {
          params: {
              ...this.queryParameters,
              page: this.adlCurrentPage,
              limit: 1000
          }
      });

      const newAdlData = response.data.result.map((item) => ({
          ...item,
          Date: item.DateTZ || tz(item.Date, this.userTimezone).format("YYYY-MM-DD"),
      }));

      // Append new data to existing data
      this.adlData = [...this.adlData, ...newAdlData];
      this.adlPagination = response.data.pagination;

  } catch (error) {
      console.error('Error loading more ADL data:', error);
      this.msg = true;
      this.text = "Failed to load more ADL data. Please try again.";
  }
},

    async generateMARQuery() {
      try {
          this.isLoading = true;
          
          // Validate required fields
          if (!this.reportFilters.startDate || !this.reportFilters.endDate) {
              this.msg = true;
              this.text = "Please select start and end dates!";
              return;
          }

          // Reset pagination for new query
          this.marCurrentPage = 1;
          this.marData = [];

          // Fetch late meds data with pagination
          const response = await axios.get(`${url}/mar/report/performance/late/mar`, {
              params: {
                  ...this.queryParameters,
                  page: this.marCurrentPage,
                  limit: 1000 // Load 1000 records per page
              }
          });

          const marData = response.data.result;
          
          // Process and format the data
          this.marData = this.processLateMedsData(marData);
          
          // Update summary statistics
          this.latePercentage = response.data.latePercentage;
          this.totalTimesheets = response.data.totalEntries;
          this.lateEntries = response.data.lateEntries;
          this.marPagination = response.data.pagination;

          // Show results
          this.showMAR = true;
          this.showResults = true;

      } catch (error) {
          console.error('Error fetching MAR data:', error);
          this.msg = true;
          this.text = "Failed to fetch MAR data. Please try again.";
      } finally {
          this.isLoading = false;
      }
    },

    async loadMoreMARData() {
      try {
          if (!this.marPagination || !this.marPagination.hasMore) {
              return;
          }
          this.marCurrentPage++;
          const response = await axios.get(`${url}/mar/report/performance/late/mar`, {
              params: {
                  ...this.queryParameters,
                  page: this.marCurrentPage,
                  limit: 1000
              }
          });
          const newMarData = this.processLateMedsData(response.data.result);
          this.marData = [...this.marData, ...newMarData];
          this.marPagination = response.data.pagination;
      } catch (error) {
          console.error('Error loading more MAR data:', error);
          this.msg = true;
          this.text = "Failed to load more MAR data. Please try again.";
      }
    },

    processLateMedsData(marData) {
      console.log('Processing MAR data:', marData.length, 'items');
      
      return marData.map(item => {
          try {
              // Extract the date when medication should have been administered
              const expectedDate = this.extractExpectedDate(item);
              
              console.log('Processed item:', {
                  original: item.timeDifference,
                  expectedDate: expectedDate
              });
              
              return {
                  ...item,
                  Date: expectedDate
                  // timeDifference is already calculated by the backend
              };
          } catch (error) {
              console.warn('Error processing MAR item:', item, error);
              return {
                  ...item,
                  Date: item.Date || 'Invalid Date'
              };
          }
      });
    },

    extractExpectedDate(item) {
      // Use DateTZ if available (from both regular MAR endpoint and performance report)
      if (item.DateTZ) {
          return item.DateTZ;
      }
      
      // Fallback: For performance report endpoint, the Date field is already in the user's timezone
      // Format: "YYYY-MM-DD HH:mm:ss" (e.g., "2025-07-27 19:08:04")
      if (item.Date) {
          // Extract just the date part (YYYY-MM-DD)
          return item.Date.split(' ')[0];
      }
      
      return 'Invalid Date';
    },





    clearFilters(){
      this.showResults = false;
      this.showMAR = false;
      this.showADL = false;
      this.showClockIn = false;
    },

    generateReport() {
      // Clear previous results
      this.clearFilters();
      
      // Route to appropriate report generation method based on report type
      switch(this.reportFilters.newReport) {
        case 'Late Clock In':
        case 'Late Clock Out':
          this.generateClockInQuery();
          break;
        case 'Late ADL\'s':
          this.generateADLQuery();
          break;
        case 'Late Meds':
          this.generateMARQuery();
          break;
        case 'Inservice Training':
          this.generateTrainingQuery();
          break;
        default:
          this.msg = true;
          this.text = "Please select a report type!";
          break;
      }
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newImage.splice(index, 1);
    },

   printTable() {
      window.print()
    
  },
  }
}
</script>
<style scoped>
.v-data-table {
border: 1px solid #e0e0e0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
overflow-x: auto;
}

.v-data-table ::v-deep tbody tr:hover {
background-color: #f5f5f5 !important;
}

.v-btn {
text-transform: none;
letter-spacing: 0;
}

.v-text-field ::v-deep .v-input__prepend-inner {
margin-top: 8px !important;
}

.v-select ::v-deep .v-input__prepend-inner {
margin-top: 8px !important;
}

.rounded-lg {
border-radius: 8px !important;
}

.rounded-t-lg {
border-top-left-radius: 8px !important;
border-top-right-radius: 8px !important;
}

#print {
display: none
}

@media only screen and (min-width: 768px) {
.mobile {
  display: none;
}
}

@media only screen and (max-width: 600px) {
.desktop {
  display: none;
}
}

@media print { 
#print{ 
  display: block; 
  border: none; 
  width: 1200px;
  padding-right: 300px;
  margin-left: -200px;
}

nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
  display: none;
  border: none; 
}

@page { margin: 0; }
body { margin: 1.6cm; }
} 
</style>